function waitForSwiper() {
  return new Promise((resolve) => {
    if (typeof Swiper !== 'undefined') {
      resolve();
    } else {
      setTimeout(() => waitForSwiper().then(resolve), 100);
    }
  });
}

async function initBestSellersCarousel() {
  const bestSellersSections = document.querySelectorAll('.s2g-homepage-best-sellers');

  bestSellersSections.forEach((section) => {
    const swiperContainer = section.querySelector('.best-sellers--carousel.swiper');

    if (!swiperContainer) return;

    const swiperNavigation = swiperContainer.closest(".content-layer").querySelector('.best-sellers--swiper-navigation');
    const prevButton = swiperNavigation.querySelector('.swiper-button-prev');
    const nextButton = swiperNavigation.querySelector('.swiper-button-next');

    // We assume Swiper is loaded globally
    if (typeof Swiper !== 'undefined') {
      new Swiper(swiperContainer, {
        slidesPerView: 1.1,
        addIcons: false,
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton,
        },
        breakpoints: {
          470: {
            slidesPerView: 'auto'
          },
          992: {
            slidesPerView: 'auto',
            slidesPerGroup: 1,
            slidesPerGroupAuto: true,
          },
        },
      });
    }
  });
}

async function hydrateBestSellers() {
  await waitForSwiper();
  initBestSellersCarousel();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', hydrateBestSellers);
} else {
  hydrateBestSellers();
}
